import { Accordion, Flex, Text, useToast } from '@chakra-ui/react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { ItemTopicos } from './ItemTopicos'
import { Button } from '../../../../components/Button'
import { gerarGpt } from '../functions/gerarGpt'
import { useMutation } from 'react-query'

export const ListaTopicos = ({ nomeCidade }) => {
  const { fields, remove } = useFieldArray({
    name: 'duvidas.topicos',
  })

  const { setValue } = useFormContext()

  const toast = useToast({
    position: 'top-right',
  })

  const {
    mutateAsync: gerarGptAsync,
    isLoading: isLoadingGerarGpt,
    isSuccess,
  } = useMutation({
    mutationFn: gerarGpt,
    onSuccess: (data) => {
      const { campo, conteudo } = data

      toast({
        title: 'Conteúdo gerado com sucesso!',
        description: `Campo: ${campo}`,
        status: 'success',
      })

      if (campo === 'topicos') {
        setValue('duvidas.topicos', conteudo)
        return
      }
    },
    onError: () => {
      toast({
        title: 'Erro ao gerar conteúdo',
        status: 'error',
      })
    },
  })

  return (
    <>
      <Button
        onClick={() => gerarGptAsync({ cidade: nomeCidade, campo: 'topicos' })}
        colorScheme="blue"
        size="lg"
        bgColor="blue.500"
        isLoading={isLoadingGerarGpt}
        mr="auto"
      >
        Gerar Tópicos
      </Button>

      <Text fontSize="23px" fontWeight="bold">
        Dúvidas - Tópicos
      </Text>
      <Flex flexDir="column" gap={2}>
        <Accordion allowToggle>
          {fields?.map((field, index) => (
            <ItemTopicos key={field.id} field={field} remove={remove} index={index} isLoadingGerarGpt={isLoadingGerarGpt} isSuccess={isSuccess} />
          ))}
        </Accordion>
        {/* <Button colorScheme="green" size="sm" alignSelf="flex-end" justifySelf="flex-end" onClick={() => append({ pergunta: '', resposta: '' })}>
        Adicionar
      </Button> */}
      </Flex>
    </>
  )
}
